export const InputRegexPatterns = {
  bnCode: /^[a-zA-Z0-9-_.]*?$/,
  clientId: /^[\w-]+$/,
  partnerName: /^[\w\s]+$/,
  encryptedAccountNumber: /^[2-9A-HJ-NP-Z]{13}$/ // https://github.paypal.com/ApiSpecifications-R/CommonComponentsSpecification/blob/48df61a12f34a96c8aab55c36385d7075fdcc280/v5/schema/json/openapi-2.0/domains/identity/account/account_id.json#L7
};
